// Writing a contact's vCard to an NFC tag (Web NFC, Chrome on Android): tap
// "Write to an NFC tag", then hold a writable tag to the phone. Shown only
// where the browser can.
import { Controller } from "@hotwired/stimulus";

export default class NfcWriteController extends Controller<HTMLElement> {
  static override targets = ["section", "status", "button"];
  static override values = { vcard: String };

  declare readonly sectionTarget: HTMLElement;
  declare readonly statusTarget: HTMLElement;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly vcardValue: string;

  override connect(): void {
    if ("NDEFReader" in window) this.sectionTarget.classList.remove("hidden");
  }

  async write(): Promise<void> {
    this.buttonTarget.disabled = true;
    this.say("waiting");
    try {
      await new NDEFReader().write({
        records: [{ recordType: "mime", mediaType: "text/vcard", data: new TextEncoder().encode(this.vcardValue) }],
      });
      this.say("written");
    } catch {
      this.say("failed");
    } finally {
      this.buttonTarget.disabled = false;
    }
  }

  // The status line's messages are its data attributes, translated by the page.
  private say(key: string): void {
    this.statusTarget.textContent = this.statusTarget.dataset[key] ?? "";
  }
}
